import { useMemo } from "react";
import { useParams } from "react-router-dom";

import { useGetCreditCards } from "@/api/creditCard";

import CreditCardItem from "./components/CreditCardItem";

const CreditCardDetail = () => {
  const { id } = useParams<{ id: string }>();
  const { data } = useGetCreditCards();

  const searchData = useMemo(
    () => (data?.cards ?? []).find((item) => item.id === Number(id)),
    [data, id]
  );

  if (!data || !searchData) {
    return null;
  }

  return (
    <div className="max-w-6xl mx-[10px] md:mx-auto">
      <CreditCardItem isDetail data={searchData} categories={data.categories} />;
    </div>
  );
};
export default CreditCardDetail;
